<template lang="pug">
  .combo-image-tile
    .textpart(v-if="!imageFirst")
      Message(
        :fontSizes="[30, 16]"
        :title="title"
        :subtitle="subtitle"
      )
    img.tile-picture(:src="iconSrc" v-if="!imageFirst")
    img.tile-picture(:src="iconSrc" v-if="imageFirst")
    .textpart(v-if="imageFirst")
      Message(
        :fontSizes="[30, 16]"
        :title="title"
        :subtitle="subtitle"
      )
</template>

<script>
import Message from '@/components/Shared/Message.vue'

export default {
  name: 'ComboImageTile',
  components: {
    Message
  },
  computed: {
    iconSrc () {
      return require(`@/assets/imagesnew/${this.icon}`)
    },
    imageFirst () {
      return window.innerWidth > 991 && !this.direction
    }
  },
  props: {
    title: {
      type: String,
      default: 'Focus on leveraging data available online'
    },
    subtitle: {
      type: String,
      default: 'Online-available information is plentiful and growing exponentially. Yet in most sectors, executives have long lacked the tools to make the most of it. We deliver software solutions continuously gathering, analyzing and rendering such data to support private market investors and business executives in their decision-making.'
    },
    icon: {
      type: String,
      default: 'online-data.jpg'
    },
    direction: {
      type: Number,
      default: 0
    }
  }
}



</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">


$color-title: #364149;
$color-subtitle: #767F86;
.combo-image-tile{
  display: flex;
  justify-content: space-between;
  margin-bottom: 3em;
  .tile-picture{
    box-shadow: 8px 9px 15px rgba(118, 127, 134, 0.15);
    width: 510px;
  }
  .textpart {
    display: flex;
    flex-direction: column;
  } 
}

@media only screen and (min-width: 991px) {
  .combo-image-tile{
    flex-direction: row;
    .textpart {
      width: 40%;
    }
  }
}
@media only screen and (max-width: 991px) {
  .combo-image-tile{
    flex-direction: column;
    align-items: center;
    .tile-picture{
      margin-top: 38px;
    }
    .textpart {
      width: 100%;
    }
  }
}

</style>
